/**
 * AttachmentModalFooter Component
 * Displays attachment metadata (size, created date) in modal footer
 */
import '../styles/AttachmentModalFooter.css'

export default function AttachmentModalFooter({ attachment }) {
  if (!attachment) return null

  return (
    <div className="attachment-modal-footer">
      <div className="attachment-modal-footer-info">
        {attachment.size && (
          <span>Size: {(attachment.size / 1024 / 1024).toFixed(2)} MB</span>
        )}
        {attachment.createdAt && (
          <span>
            Created: {new Date(attachment.createdAt).toLocaleDateString()}
          </span>
        )}
      </div>
    </div>
  )
}
